import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "DashboardFilterInputs" */'./QuickFilterGroupFilterOperatorCRMInput').then(module => module.QuickFilterGroupFilterOperatorCRMInput);
export const AsyncQuickFilterGroupFilterOperatorCRMInput = Loadable({
  loader,
  LoadingComponent: () => null
});